module.exports = __webpack_public_path__ + "static/media/arrow-down-white.bab0b685.svg";